<template>
    <div class="login-container">
        <div class="login-background">
            <div class="bg-animation"></div>
        </div>
        
        <div class="login-box">
            <div class="login-header">
                <img src="/logo.png" class="login-logo" alt="Logo" onerror="this.style.display='none'" />
                <h1 class="login-title">羊驼考务 - 招录管理系统</h1>
                <p class="login-subtitle">高校招生录取数据管理平台</p>
            </div>

            <el-form :model="loginForm" :rules="rules" ref="loginForm" class="login-form">
                <el-form-item prop="phone">
                    <el-input
                        v-model="loginForm.phone"
                        placeholder="请输入手机号"
                        prefix-icon="el-icon-mobile-phone"
                        size="large"
                        maxlength="11">
                    </el-input>
                </el-form-item>

                <el-form-item prop="password">
                    <el-input
                        v-model="loginForm.password"
                        type="password"
                        placeholder="请输入密码"
                        prefix-icon="el-icon-lock"
                        size="large"
                        show-password
                        @keyup.enter.native="handleLogin">
                    </el-input>
                </el-form-item>

                <el-form-item prop="captcha">
                    <div class="captcha-row">
                        <el-input
                            v-model="loginForm.captcha"
                            placeholder="请输入验证码"
                            prefix-icon="el-icon-picture"
                            size="large"
                            maxlength="4"
                            @keyup.enter.native="handleLogin">
                        </el-input>
                        <img :src="captchaUrl" class="captcha-img" @click="refreshCaptcha" title="点击刷新">
                    </div>
                </el-form-item>

                <el-form-item>
                    <el-checkbox v-model="loginForm.remember">记住密码</el-checkbox>
                </el-form-item>

                <el-form-item>
                    <el-button
                        type="primary"
                        size="large"
                        :loading="loading"
                        @click="handleLogin"
                        class="login-button">
                        <span v-if="!loading">登 录</span>
                        <span v-else>登录中...</span>
                    </el-button>
                </el-form-item>
            </el-form>

            <div class="login-footer">
                <p>如遇问题，请联系系统管理员</p>
            </div>
        </div>
    </div>
</template>

<script>
import { TYBM_Env } from '../env.js';
import { TYBM_Tools } from '../tools.js';

export default {
    name: 'Login',
    data() {
        const validatePhone = (rule, value, callback) => {
            if (!value) {
                callback(new Error('请输入手机号'));
            } else if (!/^1[3-9]\d{9}$/.test(value)) {
                callback(new Error('请输入正确的手机号'));
            } else {
                callback();
            }
        };

        return {
            loginForm: {
                phone: '',
                password: '',
                captcha: '',
                remember: false
            },
            rules: {
                phone: [
                    { required: true, validator: validatePhone, trigger: 'blur' }
                ],
                password: [
                    { required: true, message: '请输入密码', trigger: 'blur' },
                    { min: 6, message: '密码长度不能少于6位', trigger: 'blur' }
                ],
                captcha: [
                    { required: true, message: '请输入验证码', trigger: 'blur' },
                    { len: 4, message: '验证码为4位', trigger: 'blur' }
                ]
            },
            loading: false,
            captchaUrl: ''
        };
    },
    methods: {
        handleLogin() {
            this.$refs.loginForm.validate((valid) => {
                if (valid) {
                    this.loading = true;
                    const api_name = '/Admin/Login';
                    const url = TYBM_Env.GetApiUrl(api_name);
                    
                    // 使用GxzsSubmitApi规范，将参数封装到Model中
                    TYBM_Tools.AxiosPostEx(this, api_name, url, {
                        Model: JSON.stringify({
                            Phone: this.loginForm.phone,
                            Password: this.loginForm.password,
                            Captcha: this.loginForm.captcha
                        })
                    }, { loading_msg: '正在登录' })
                        .then(() => {
                            this.$message.success('登录成功');
                            
                            // 保存登录信息
                            if (this.loginForm.remember) {
                                localStorage.setItem('phone', this.loginForm.phone);
                                localStorage.setItem('password', this.loginForm.password);
                            } else {
                                localStorage.removeItem('phone');
                                localStorage.removeItem('password');
                            }

                            // 跳转到首页
                            setTimeout(() => {
                                this.$router.push('/Info/ListSanBiao');
                            }, 500);
                        })
                        .catch(() => {
                            this.refreshCaptcha();
                        })
                        .finally(() => {
                            this.loading = false;
                        });
                } else {
                    return false;
                }
            });
        },
        refreshCaptcha() {
            // 刷新验证码
            this.captchaUrl = TYBM_Env.GetApiUrl('/Admin/GetCaptcha') + '?t=' + new Date().getTime();
        },
        loadRememberedInfo() {
            // 加载记住的登录信息
            const phone = localStorage.getItem('phone');
            const password = localStorage.getItem('password');
            if (phone && password) {
                this.loginForm.phone = phone;
                this.loginForm.password = password;
                this.loginForm.remember = true;
            }
        }
    },
    mounted() {
        this.refreshCaptcha();
        this.loadRememberedInfo();
    }
};
</script>

<style scoped>
.login-container {
    width: 100vw;
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    overflow: hidden;
}

.login-background {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
}

.bg-animation {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-image: 
        radial-gradient(circle at 20% 50%, rgba(255, 255, 255, 0.1) 0%, transparent 50%),
        radial-gradient(circle at 80% 80%, rgba(255, 255, 255, 0.1) 0%, transparent 50%),
        radial-gradient(circle at 40% 20%, rgba(255, 255, 255, 0.1) 0%, transparent 50%);
    animation: float 20s ease-in-out infinite;
}

@keyframes float {
    0%, 100% {
        transform: translate(0, 0);
    }
    33% {
        transform: translate(30px, -30px);
    }
    66% {
        transform: translate(-20px, 20px);
    }
}

.login-box {
    background: white;
    border-radius: 16px;
    padding: 48px 40px;
    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
    width: 440px;
    max-width: 90%;
    position: relative;
    z-index: 1;
    animation: slideIn 0.5s ease-out;
}

@keyframes slideIn {
    from {
        opacity: 0;
        transform: translateY(-50px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

.login-header {
    text-align: center;
    margin-bottom: 40px;
}

.login-logo {
    height: 60px;
    margin-bottom: 16px;
}

.login-title {
    font-size: 24px;
    font-weight: 600;
    color: #303133;
    margin: 0 0 8px 0;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
}

.login-subtitle {
    font-size: 14px;
    color: #909399;
    margin: 0;
}

.login-form {
    margin-top: 32px;
}

.login-form >>> .el-input__inner {
    height: 48px;
    line-height: 48px;
    border-radius: 8px;
}

.login-form >>> .el-input__prefix {
    line-height: 48px;
}

.captcha-row {
    display: flex;
    gap: 12px;
}

.captcha-row .el-input {
    flex: 1;
}

.captcha-img {
    width: 120px;
    height: 48px;
    border-radius: 8px;
    cursor: pointer;
    border: 1px solid #DCDFE6;
    transition: all 0.3s;
}

.captcha-img:hover {
    border-color: #409EFF;
    box-shadow: 0 0 8px rgba(64, 158, 255, 0.3);
}

.login-button {
    width: 100%;
    height: 48px;
    font-size: 16px;
    font-weight: 600;
    border-radius: 8px;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    border: none;
    transition: all 0.3s;
}

.login-button:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 16px rgba(102, 126, 234, 0.4);
}

.login-footer {
    text-align: center;
    margin-top: 24px;
    font-size: 12px;
    color: #909399;
}

@media (max-width: 480px) {
    .login-box {
        padding: 32px 24px;
        width: 95%;
    }

    .login-title {
        font-size: 20px;
    }
}
</style>

